import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { List, Icon, Button } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import SuggestedFieldType, { SuggestedFieldTypeMap } from "~/constants/UiMeet3d/GreetingBot/SuggestedFieldType";
import CustomField from "~/models/UiMeet3d/GreetingBot/CustomField";

const suggestedFields = [
  {
    key: 0,
    translationKey: "clientPanelMisc:singleFieldForBothFirstNameAndLastName",
    field: SuggestedFieldTypeMap[SuggestedFieldType.TYPE_NAME],
  },
  {
    key: 1,
    translationKey: "clientPanelMisc:contactPhone",
    field: SuggestedFieldTypeMap[SuggestedFieldType.TYPE_PHONE],
  },
  {
    key: 2,
    translationKey: "emailAddress",
    field: SuggestedFieldTypeMap[SuggestedFieldType.TYPE_EMAIL],
  },
  {
    key: 3,
    translationKey: "clientPanelMisc:aCustomMessageForYou",
    field: SuggestedFieldTypeMap[SuggestedFieldType.TYPE_MESSAGE],
  },
];

@observer
class GreetingBotSimpleFormBuilder extends Component {
  render() {
    const { onFieldAdd, t } = this.props;

    return (
      <div className="greeting-bot-form-wrap">
        <p>{t("clientPanelMisc:addSuggestedFields")}</p>
        <List divided verticalAlign="middle">
          {suggestedFields.map(customField => (
            <List.Item key={customField.key}>
              <Icon name="right triangle" />
              <List.Content>
                <List.Header>{t(customField.field.translationKey)}</List.Header>
                <List.Description>
                  <p>{t(customField.translationKey)}</p>
                </List.Description>
                <Button basic color="green" onClick={() => onFieldAdd(new CustomField(customField.field))}>
                  {t("add")}
                </Button>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </div>
    );
  }
}

GreetingBotSimpleFormBuilder.propTypes = {
  t: PropTypes.func.isRequired,
  onFieldAdd: PropTypes.func.isRequired,
};

export default withTranslation()(GreetingBotSimpleFormBuilder);
